
// updated 2025-03-28

export const searchExamples = [
	'pioglitazone',
	'pioglitazone, glimepiride',
	'erlotinib hydrochloride',
	'venetoclax',
	'vemurafenib',
	'lenvatinib mesilate',
	'ipragliflozin l-proline',
	'etravirine',
	'brigatinib',
	'semaglutide',
	'varenicline tartrate',
	'crizotinib',
	'sunitinib malate',
	'palbociclib',
	'temsirolimus',
	'bosutinib',
	'tigecycline',
	'leuprorelin',
	'imatinib',
	'cobimetinib fumarate',
	'axitinib',
	'alectinib',
	'azilsartan medoxomil',
	'bortezomib',
	'azithromycin',
	'ponatinib',
	'ceftaroline fosamil',
	'dabrafenib',
	'azilsartan, amlodipine',
	'pioglitazone, metformin',
	'nilotinib',
	'trametinib',
	'abemaciclib',
	'alogliptin, metformin',
	'alogliptin, pioglitazone',
	'trelagliptin',
	'azilsartan',
	'sitagliptin phosphate',
	'sitagliptin phosphate, metformin hcl',
	'azilsartan medoxomil, chlortalidone',
	'avibactam sodium with ceftazidime pentahydrate',
	'rilpivirine',
	'darunavir',
	'rilpivirine/tenofovir alafenamide/emtricitabine',
	'macitentan',
	'selexipag',
	'epoprostenol',
	'vildagliptin',
	'rilpivirine, emtricitabine, tenofovir disoproxyl fumarate',
	'enzalutamide',
	'ixazomib',
	'everolimus',
	'glycopyrronium bromide',
	'bedaquiline',
	'indacaterol, glycopyrronium bromide',
	'indacaterol',
	'pazopanib',
	'tobramycin',
	'zoledronic acid',
	'deferasirox',
	'ceritinib',
	'dasatinib',
	'lapatinib',
	'apixaban',
	'amlodipine, valsartan, hydrochlorothiazide',
	'sacubitril, valsartan',
	'amlodipine, olmesartan medoxomil',
	'fingolimod',
	'olmesartan medoxomil, hydrochlorothiazide',
	'levodopa, carbidopa, entacapone',
	'ombitasvir, dasabuvir, paritaprevir, ritonavir',
	'midostaurin',
	'moxifloxacin',
	'mycophenolic acid',
	'olmesartan medoxomil, amlodipine, hydrochlorothiazide',
	'nepafenac',
	'ruxolitinib',
	'ribociclib',
	'rivastigmine',
	'olopatadine hydrochloride',
	'travoprost',
	'travoprost, timolol',
	'eltrombopag',
	'glasdegib',
	'gilteritinib fumarate',
	'metaxalone',
	'parecoxib sodium',
	'medroxyprogesterone acetate',
	'bazedoxifene with estrogens conjugated',
	'exemestane',
	'bazedoxifene acetate',
	'baloxavir marboxil',
	'isavuconazonium sulfate',
	'dacomitinib',
	'crisaborole',
	'pantoprazole sodium',
	'talazoparib',
	'tavaborole',
	'lorlatinib',
	'anidulafungin',
	'tofacitinib citrate',
	'desvenlafaxine succinate',
	'tafamidis meglumine',
	'doravirine',
	'alogliptin',
	'doravirine, lamivudine, tenofovir disoproxil',
	'cilastatin sodium, imipenem, relebactam',
	'rivaroxaban',
	'lacosamide',
	'ciprofloxazin',
	'rotigotine',
	'riociguat',
	'regorafenib',
	'encorafenib',
	'dexmedetomidine',
	'selpercatinib',
	'larotrectinib',
	'binimetinib',
	'moxifloxazin',
	'cefiderocol',
	'glecaprevir, pibrentasvir',
	'piperacillin with tazobactam',
	'rivaroxaban, acetylsalicylic acid, clopidogrel',
	'abrocitinib',
	'alpelisib',
	'siponimod',
	'sorafenib',
	'vildagliptin, metformin hydrochloride',
	'brinzolamide, brimonidine tartrate',
	'tepotinib',
	'cladribine',
	'risdiplam',
	'fluticasone furoate',
	'vismodegib',
	'entrectinib',
	'amoxicillin, clavulanate potassium',
	'dolutegravir sodium, lamivudine',
	'carvedilol phosphate',
	'cabotegravir, rilpivirine',
	'fluticasone propionate',
	'lamivudine',
	'umeclidinium bromide',
	'lamotrigine',
	'fosamprenavir calcium',
	'dolutegravir sodium, rilpivirine hydrochloride',
	'sumatriptan',
	'ropinirole hydrochloride',
	'fluticasone furoate, vilanterol trifenatate',
	'fostemsavir',
	'rosiglitazone',
	'umeclidinium bromide, vilanterol trifenatate',
	'metformin hydrochloride, rosiglitazone maleate',
	'maraviroc',
	'alitretinoin',
	'fluticasone propionate, salmeterol xinafoate',
	'dolutegravir sodium',
	'fluticasone furoate, umeclidinium bromide, vilanterol trifenatate',
	'abacavir sulfate, dolutegravir sodium, lamivudine',
	'albuterol sulfate',
	'abacavir sulfate, lamivudine, zidovudine',
	'cabotegravir',
	'ambrisentan',
	'bupropion xl',
	'abacavir sulfate',
	'niraparib tosylate',
	'indacaterol, glycopyrronium, mometasone furoate',
	'vericiguat',
	'abiraterone acetate',
	'nirmatrelvir',
	'belzutifan',
	'apalutamide',
	'bosentan',
	'sacituzumab govitecan',
	'emtricitabine, rilpivirine, tenofovir alafenamide',
	'emtricitabine, tenofovir disoproxil fumarate',
	'tenofovir alafenamide',
	'emtricitabine, rilpivirine, tenofovir disoproxil fumarate',
	'lenacapavir',
	'darunavir, cobicistat, emtricitabine, tenofovir alafenamide',
	'darunavir, cobicistat',
	'cobicistat',
	'sofosbuvir, velpatasvir',
	'idelalisib',
	'atazanavir, cobicistat',
	'bulevirtide',
	'emtricitabine',
	'sofosbuvir',
	'copanlisib',
	'finerenone',
	'erdafitinib',
	'rilpivirine, dolutegravir',
	'rilpivirine, cabotegravir',
	'paliperidone',
	'efavirenz, emtricitabine, tenofovir disoproxil fumarate',
	'sofosbuvir, velpatasvir, voxilaprevir',
	'tenofovir disoproxil fumarate',
	'darunavir, cobicistat',
	'darunavir, cobicistat, emtricitabine, tenofovir alafenamide',
	'pirtobrutinib',
	'voxelotor',
	'baqsimi',
	'lasmiditan',
	'ensitrelvir',
	'zavegepant',
	'enasidenib',
	'fedratinib',
	'macitentan, tadalafil',
	'paclitaxel',
	'ritlecitinib',
	'brivaracetam',
	'levetiracetam',
	'rimegepant',
	'inclisiran',
	'capmatinib',
	'tucatinib',
	'etrasimod',
	'tafamidis',
	'ertugliflozin',
	'fesoterodine',
	'avibactam, aztreonam',
	'lenalidomide',
	'zilucoplan',
	'fruquintinib',
	'repotrectinib'
]